import CssBaseline from '@mui/material/CssBaseline';
import Container from '@mui/material/Container';
import AppAppBar from '../components/AppAppBar';
import AppTheme from '../AppTheme';
import Box from '@mui/material/Box';
import Dashboard from '../components/Dashboard';

// 學術風格背景
const backgroundSx = {
position: "fixed",     // 固定在螢幕
top: 0,
left: 0,
width: "100vw",        // 全螢幕寬
height: "100vh",       // 全螢幕高
zIndex: -1,            // 放在最底層，避免遮擋內容
backgroundColor: '#f6f4ea',
backgroundImage: `
    radial-gradient(1000px 600px at 20% -10%, rgba(255,255,255,0.7), rgba(255,255,255,0) 60%),
    radial-gradient(900px 500px at 120% 0%, rgba(255,255,255,0.55), rgba(255,255,255,0) 65%),
    linear-gradient(180deg, rgba(0,0,0,0.03) 1px, transparent 1px),
    linear-gradient(90deg, rgba(0,0,0,0.03) 1px, transparent 1px)
`,
backgroundSize: `
    auto,
    auto,
    100% 28px,
    28px 100%
`,
}; 

export default function UserPage(props) {
  return (
    <AppTheme {...props}>
      <CssBaseline enableColorScheme />
      <AppAppBar />
      <Box sx={backgroundSx} />   {/* 背景層 */}
      <Container
        maxWidth="lg"
        component="main"
        sx={{ display: 'flex', flexDirection: 'column', my: 16, gap: 4, mt:12 }}
      >
        <Dashboard />
      </Container>
    </AppTheme>
  );
}
